import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from '../services/auth-service.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/timeout';
import { environment } from '../../environments/environment';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).timeout(500000).do(event => { }, err => { // timeout of 500000 ms or 8.3 minutes, that is a long time!
      if (err instanceof HttpErrorResponse) {
        if (req.url.indexOf(environment.S1Url) >= 0 || req.url.indexOf(environment.fezeUrl) >= 0) {
          console.log("Error Caught By Interceptor");
          console.log(err);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/timeout.interceptor.ts